import { DBManager } from "../db/dbManager";
import { getDayOfWeek } from "../utils/DateTimeUtils";
import { isCuPhapMb } from "../utils/common";

export async function GetDaiQuayTrongNgay(mienDaiCuocId: number, ngay: string): Promise<string[]> {
    if (isCuPhapMb()){
        return ["HN"]
    }
    let promise = new Promise<string[]>((resolve, reject) => {
        DBManager.getDBConnection().then(db => {
            let objStore = db.transaction("daiNgayQuay", "readonly")
                .objectStore("daiNgayQuay")
            const request = objStore.getAll()
            request.onsuccess = async () => {
                const data: string[] = []
                const thu = getDayOfWeek(ngay)
                //1
                const promise = request.result.map(async (item) => {
                    await DBManager.readDataByPrimarykey("dmDai", item.daiId, "daiId").then((dais: any[]) => {
                        if (item.thu == thu) {
                            dais.map(it => {
                                if (it.mienDaiCuocId == mienDaiCuocId) {
                                    data.push(item.daiId)
                                }
                            })
                        }
                    })

                })
                // Chờ tất cả các promises hoàn thành
                await Promise.all(promise)
                //2
                // Sau khi tất cả promises đã hoàn thành, thực hiện resolve
                resolve(data)
            }
        })
    })

    return promise;
}
export async function GetNhanVe(daiSelected:string[], groupCuocSelected:string[]){
    
}